module.exports = __webpack_public_path__ + "static/media/24x24.2d0009fd.png";